import { createTheme } from '@mui/material/styles';
import {green,purple,lime,deepOrange,grey,amber} from '@mui/material/colors';
import {ThemeProvider} from '@mui/material/styles';
import {useSelector} from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';
import './customFonts.css'
import * as React from 'react';
import Router from './routers'



export default function App() {

  const get_theme = (mode)=>({
  palette:{
    ...(mode === 'light'
      ? {
          mode:'light',
          primary:{
            main:'#FFFFFF'
          },
          divider:'#c99405',
          background:{
            default:'#fff',
            paper:'#fff'
            },
          text:{
            primary:'#060202',
            secondary:grey[900]
            },
          typography: {
            fontFamily: `"zolla","geruduk","modellista","darling","dinofans","north","banerton","preparatori","nsai", sans-serif`, 
          }
        }
      :
      {
          mode:'dark',
          primary:{
            main:'#0e0d0d'
          },
          secondary:{
            main: deepOrange[900]
          },
          divider:'#c99405',
          text:{
            primary:'#fff',
            secondary: deepOrange[900]
            },
          background:{
            default:'#060202',
            paper:'#060202'
            },
          typography: {
            fontFamily: `"zolla","geruduk","modellista","darling","dinofans","north","banerton","preparatori","nsai", sans-serif`, 
          }
        }

      ),
  }
})

const mode = useSelector(state => state.theme?.mode);

const theme =  createTheme(get_theme(mode))

  return (
    <React.StrictMode>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router/>
        </ThemeProvider>
  </React.StrictMode>

  );
}
